import { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import validator from "validator";
import UserService from "../../services/user.service";
import MenuService from "../../services/menu.service";
import FormInputText from "../../components/FormField/FormInput";
import { AuthContext, setAuthStorage } from "../../contexts/AuthContext";
import logo from "../../images/logo.png";
import "./Login.scss";

const Login = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [passwordError, setpasswordError] = useState("");
  const [emailError, setemailError] = useState("");
  const [formValid, setFormValid] = useState(false);

  const { setIsLoggedIn, setUser, setIsLoading, setAuthToken, setMenuList } =
    useContext(AuthContext);

  const handleValidation = (event) => {
    let formIsValid = true;

    if (!validator.isEmail(email)) {
      formIsValid = false;
      setemailError("Email Not Valid");
    } else {
      setemailError("");
      formIsValid = true;
    }

    if (
      !validator.isStrongPassword(password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      formIsValid = false;
      setpasswordError(
        "Must contain 8 characters, one uppercase letter, one lowercase letter, one number, and one special symbol"
      );
    } else {
      setpasswordError("");
      formIsValid = true;
    }
    setFormValid(formIsValid);
    return formIsValid;
  };

  const loginSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        setIsLoading(true);
        const resp = await UserService.login({
          email,
          password,
        });
        if (resp.data && resp.data.success && resp.data.token) {
          toast.success("Logged In Successfully!");
          setAuthToken(resp.data.token);
          setAuthStorage(resp.data.token);
          await userProfile();
        } else {
          setIsLoading(false);
          toast.error(resp.data ? resp.data.message : "User Login Error");
        }
      } catch (err) {
        console.error("User Login error catch => ", err);
        setIsLoading(false);
        toast.error(err.response.data.msg || "Error occurred");
      }
    }
  };

  async function userProfile() {
    try {
      const resp = await UserService.profile();
      if (resp.data && resp.data.success) {
        setIsLoggedIn(true);
        setUser(resp.data.data);
        await fetchSideMenuData();
      } else {
        toast.error(resp.data ? resp.data.message : "User Profile Error");
      }
      setIsLoading(false);
    } catch (err) {
      console.error("User Profile error catch => ", err);
      setIsLoading(false);
      toast.error(err.message);
    }
  }

  const fetchSideMenuData = async () => {
    try {
      const resp = await MenuService.getAll();
      if (resp.data.success) {
        setMenuList(
          resp.data.data && resp.data.data.length ? resp.data.data : []
        );
      }
    } catch (err) {
      console.error("Side Menus error catch => ", err);
      setIsLoading(false);
      toast.error(err.message);
    }
  };

  return (
    <>
      <div className="waves-container">
        <svg
          className="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="parallax">
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>

      <div className="row app bg-login">
        <div className="row login-box">
          <div className="col-sm-5 offset-sm-1 login-img">
            <img src={logo} className="logo-login" />
            <div className="logo-text">Data Standardization Tool</div>
          </div>
          <div className="col-sm-5 p-0 login-content">
            <div className="col-sm-12 mb-4 p-0 border-radius-0">
              <h2>Login</h2>
              <div className="row d-flex justify-content-center">
                <div className="col-md-12">
                  <Form
                    id="loginform"
                    onSubmit={loginSubmit}
                    className="login-form"
                  >
                    <div className="form-group mt-2">
                      <FormInputText
                        type="email"
                        placeholder="Enter Email"
                        setFunc={setEmail}
                      />
                      <small
                        id="emailHelp"
                        className="text-danger form-text mt-2"
                      >
                        {emailError}
                      </small>
                    </div>
                    <div className="form-group mt-4">
                      <FormInputText
                        type="password"
                        placeholder="Enter Password"
                        setFunc={setPassword}
                      />
                      <small
                        id="passworderror"
                        className="text-danger form-text"
                      >
                        {passwordError}
                      </small>
                    </div>
                    <div className="text-center submit-btn">
                      <Button
                        type="submit"
                        className="btn btn-dark login-btn mt-4"
                      >
                        Login
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
